<template>
	<div class="page-width">
		<datatable title="Stats" :response="data" :fields="fields" @edit_click="edit" :show_delete="false" :is_createable="false">
		</datatable>
	</div>
</template>
<script>
	import { mapMutations } from 'vuex'
	import Datatable from '@/components/Datatable'
	export default {
		name: 'recruiter-fees',
		data(){
			return {
				fields: [
					{
						name: 'Resource',
						component_data_path: 'resource',
						component: 'LinkEntity',
					},
				    {
				      name: 'Designator',
				      value: 'designator'
				    },
				    {
				      name: 'Title',
				      value: 'title'
				    },
				    {
				      name: 'Content',
				      value: 'content',
				      is_html: true,
				    },
				],
				data: [],
			}
		},
		created(){
			this.$network_utils.getStats().then(response => {
				this.data = response
			})
		},
		methods: {
			edit(data){
				this.createModal({
					component_name: 'StatForm',
					modal_title: data.designator,
				})	
			},
			...mapMutations('modals', ['createModal'])
		},
		components: {
			Datatable
		}
	}
</script>